import { ReactElement, ReactNode } from 'react';
import {
  GlobalConfig as GlobalConfigBase,
  ICloudinaryConfig,
} from '@cars4ever/public-ui';
import { BrandCode, useBrandTheme } from '@cars4ever/brand-config-core';

import WidgetLayoutProvider from '^common/WidgetLayoutProvider';
import ErrorBoundary from '^common/ErrorBoundary';
import { CLOUD_NAME, LOCALE } from '^configs/environments';
import Logger from '^utils/logger';
import ApplicationConfig from '^services/ApplicationConfig';

export interface IGlobalConfigProps {
  children: ReactNode;
}

const handleCloudinaryImageError = (src: string): void => {
  Logger.trackWarning(`Image (${src}) is not found`, {
    catcher: 'OptimizedImage.error',
  });
};

const cloudinaryConfig: ICloudinaryConfig = {
  cloudName: CLOUD_NAME,
  handleError: handleCloudinaryImageError,
};

const GlobalConfig = ({ children }: IGlobalConfigProps): ReactElement => {
  const theme = ApplicationConfig.brand;

  useBrandTheme(theme as BrandCode);

  return (
    <GlobalConfigBase
      locale={LOCALE}
      cloudinaryConfig={cloudinaryConfig}
    >
      <ErrorBoundary>
        <WidgetLayoutProvider>
          {children}
        </WidgetLayoutProvider>
      </ErrorBoundary>
    </GlobalConfigBase>
  );
};

export default GlobalConfig;
